<template>
  <section id="Section404">
    <a href="" @click.prevent="Volver">
      <svg
        height="0.8em"
        width="0.8em"
        viewBox="0 0 2 1"
        preserveAspectRatio="none"
      >
        <polyline
          fill="none"
          stroke="#777777"
          stroke-width="0.1"
          points="0.9,0.1 0.1,0.5 0.9,0.9"
        />
      </svg>
      Inicio
    </a>
    <div class="background-wrapper">
      <h1 id="visual">404</h1>
    </div>

    <p>
      <img src="../assets/img/LogoPapirusBlanco.png" /><br />La página que
      buscas no existe, intenta volver al Inicio
    </p>
  </section>
</template>
<script type="text/javascript" src="scripts.js"></script>

<style scoped>
#Section404 {
  font-family: "Poppins";
  height: 100vh;
  padding: 1em;
  overflow: hidden;
  background: rgb(2, 0, 36);
  background: linear-gradient(
    -33deg,
    rgb(52, 124, 172),
    rgb(0, 0, 0) 45%,
    rgb(0, 0, 0) 60%,
    rgb(52, 124, 172) 100%
  );
}
</style>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Eczar:800");
@import url("https://fonts.googleapis.com/css?family=Poppins:600");

.background-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.background-wrapper h1 {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%) rotate(-33deg);
  transform: translate(-50%, -50%) rotate(-33deg);
  font-family: "Eczar";
  font-size: 40vmax;
  color: #4d4a4a;
  letter-spacing: 0.025em;
  margin: 0;
  -webkit-transition: 750ms ease-in-out;
  transition: 750ms ease-in-out;
}

a {
  border: #18a8e1;
  padding: 0.5em 0.8em;
  position: fixed;
  z-index: 1;
  color: #ffffff;
  background-color: #18a8e1;
  text-decoration: none;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-transition: 150ms;
  transition: 150ms;
}
a svg > polyline {
  -webkit-transition: 150ms;
  transition: 150ms;
}
a:hover {
  color: #18a8e1;
  background: #dadada;
  border-color: transparent;
}
a:hover svg > polyline {
  stroke: #000;
}
a:hover + .background-wrapper > h1 {
  /*color: #dadada;*/
  color: #18a8e1;
}

p {
  color: #dadada;
  font-size: calc(1em + 2vmin);
  position: fixed;
  bottom: 1rem;
  right: 1.5rem;
  margin: 0;
  text-align: right;
  text-shadow: -1px -1px 0 #121212, 1px 1px 0 #121212, -1px 1px 0 #121212,
    1px -1px 0 #121212;
}
@media screen and (min-width: 340px) {
  p {
    width: 70%;
  }
}
@media screen and (min-width: 560px) {
  p {
    width: 50%;
  }
}
@media screen and (min-width: 940px) {
  p {
    width: 30%;
  }
}
@media screen and (min-width: 1300px) {
  p {
    width: 25%;
  }
}
</style>

<script>
export default {
  created() {
    var that = this;
    const visual = document.getElementById("visual");
    const events = ["resize", "load"];

    events.forEach(function (e) {
      window.addEventListener(e, that.resizePage);
    });
  },
  unmounted() {
    window.removeEventListener("resize", this.resizePage);
    window.removeEventListener("load", this.resizePage);
  },
  methods: {
    resizePage() {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const ratio = 45 / (width / height);
      visual.style.transform =
        "translate(-50%, -50%) rotate(-" + ratio + "deg)";
    },
    Volver() {
      this.$router.push({ name: "AppSolicitudes" });
    }
  }
};
</script>
